export default __webpack_public_path__ + "static/baiju-b191618267199f18da35be90c9a8bd12.png";